'use client';
import React, { useEffect, useState } from 'react';
import cn from '../style.module.scss';
export type SplidePaginationProps = {
  splideRef: React.MutableRefObject<any>;
  paginationClassName?: string;
  dotClassName?: string;
  activeDotClassName?: string;
};
export default function SplidePagination({
  splideRef,
  paginationClassName = '',
  dotClassName = '',
  activeDotClassName = '',
}: SplidePaginationProps) {
  const [length, setLength] = useState(0);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const splide = splideRef.current?.splide;
    if (!splide) return;

    const update = (newIndex?: number) => {
      setLength(splide.length);
      setActive(typeof newIndex === 'number' ? newIndex : splide.index);
    };

    update();
    // `move` fires at the start of a transition and passes the destination
    // index; `splide.index` is not updated until `moved`, so read the arg.
    splide.on('move.pagination', (newIndex: number) => update(newIndex));
    splide.on('mounted.pagination moved.pagination updated.pagination', () =>
      update()
    );

    return () => {
      splide.off('move.pagination');
      splide.off('mounted.pagination moved.pagination updated.pagination');
    };
  }, [splideRef]);

  if (length <= 1) return null;

  return (
    <ul className={`${cn.splidePagination} ${paginationClassName}`}>
      {Array.from({ length }).map((_, i) => {
        const isActive = i === active;
        return (
          <li key={i}>
            <button
              type="button"
              aria-current={isActive}
              onClick={() => splideRef.current?.splide?.go(i)}
              className={[
                cn.paginationDot,
                dotClassName,
                isActive ? cn.isActive : '',
                isActive ? activeDotClassName : '',
              ]
                .filter(Boolean)
                .join(' ')}
            />
          </li>
        );
      })}
    </ul>
  );
}
